define('SageDotCom/Components/Collections/CampaignCarousel',[
    'jquery',
    'slick'
],
    function ($) {
        function CampaignCarousel(scope, speed, autoPlay) {

            var $slick = $(".slider", scope);

            // register page level analytics relating to forms
            var time = speed / 1000;
            var $bar,
                isPause,
                tick,
                percentTime;

            var panes = $(".slide", scope);

            scope.addEventListener('lazy-load-evt', function () {
                new Promise(function (resolve, reject) {
                    $slick.slick({
                        autoplay: false,
                        draggable: true,
                        adaptiveHeight: false,
                        dots: true,
                        useTransform: false,
                        mobileFirst: true,
                        pauseOnDotsHover: true,
                        pauseOnFocus: true,
                        customPaging: function (slider, i) {
                            // todo: calculate label

                            var title = $(panes[i], scope).attr("data-title");

                            return '<span class="slide-title" tabindex="0">' +
                                title +
                                '</span><div class="slider-progress" tabindex="0"><div class="progress"></div></div>';
                        }
                    });

                    resolve();
                });
            });

            $bar = $('.slider-progress .progress', scope);

            function startProgressbar() {
                resetProgressbar();
                percentTime = 0;
                isPause = false;
                tick = setInterval(interval, 10);
            }

            function interval() {
                if (isPause === false) {
                    percentTime += 1 / (time + 0.1);
                    $bar.css({
                        width: percentTime + "%"
                    });
                    if (percentTime >= 100) {
                        $slick.slick('slickNext');
                        startProgressbar();
                    }
                }
            }

            function resetProgressbar() {
                $bar.css({
                    width: 0 + '%'
                });
                clearTimeout(tick);
            }

            // Only begin the carousel if auto play is enabled in the parameters
            // or if the user clicks the campaign carousel to begin
            if (autoPlay) {
                startProgressbar();
            } else {
                $('.slider-wrapper', scope).on("click", function (event) {
                    startProgressbar();
                });
            }

            // stop carousel on focus
            $('.score-button, .slide-title, .slider-progress', scope).focus(function () {
                isPause = true;
            }).blur(function () {
                isPause = false;
            });

            $('.slide-title', scope).on("keyup",
                function(event) {
                    //on enter key
                    if (event.keyCode === 13) {
                        $(this).click();
                    }
                });
        }

        return function init(args) {
            return args.IsExperienceEditorEditing ? null : new CampaignCarousel(args.scope, args.Speed, args.AutoPlay);
        };
    });
